import VimeoIframe from './vimeo-iframe';

export { VimeoIframe };

export default VimeoIframe;